import React from 'react'
import { connect } from 'react-redux'
import DateTime from 'react-datetime'
import moment from 'moment'
import FileUploader from '../FileUploader'
import SwitchButton from '../../Components/SwitchButton'
import Select from 'react-select'
import { currentBranch, currentRole } from '../../Utils/PrivilegeUtils'
import { includes } from 'lodash'
import FilesActions from '../../Redux/FilesRedux'
import CouponActions from '../../Redux/CouponRedux'

class CreateCoupon extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'YYYY-MM-DD'
    this.couponCodeRegex = /^[a-zA-Z0-9]*$/
    this.platforms = [
      { value: 'all', label: 'ALL' },
      { value: 'web', label: 'WEB' },
      { value: 'all-mobile', label: 'ALL-MOBILE' },
      { value: 'android', label: 'ANDROID' },
      { value: 'ios', label: 'IOS' }
    ]

    this.rentType = [
      { value: 'all', label: 'ALL' },
      { value: 'new', label: 'NEW' },
      { value: 'topup', label: 'TOP-UP' }
    ]

    this.productTypes = [
      { value: 'all', label: 'ALL' },
      { value: 'modem', label: 'MODEM' },
      { value: 'attraction', label: 'ATTRACTION' },
      { value: 'insurance', label: 'INSURANCE', restriction: ['PH'] },
      { value: 'inventory', label: 'ECOMMERCE' }
    ].filter((option) => { return (!includes(option.restriction, currentBranch()) && !includes(option.restriction, currentRole())) })

    this.iso_code = [
      { value: 'ID', label: 'INDONESIA', restriction: ['PH'] },
      { value: 'PH', label: 'PHILIPPINES' }
    ].filter((option) => { return (!includes(option.restriction, currentBranch()) && !includes(option.restriction, currentRole())) })

    this.state = {
      selectedProvider: null,
      coupon: {
        type: 'GENERIC',
        title: '',
        code: '',
        status: 'available',
        max_usage: 1,
        max_usage_per_user: 1,
        image_file: '',
        product_type: 'all',
        rent_type: 'all',
        travel_date_start: null,
        travel_date_end: null,
        min_duration: 0,
        discount_type: 'PRICE_CUT',
        discount_amount: 0,
        max_discount: 0,
        start_at: moment(),
        end_at: moment(),
        description: '',
        min_amount: 0,
        max_amount: 0,
        platform: 'all',
        first_order_only: false,
        first_user_only: false,
        provider_id: null,
        iso_code: currentBranch()
      },
      file: null,
      uploaded: false
    }
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data) {
      let coupon = { ...this.state.coupon }
      coupon['image_file'] = newProps.files.data.upload[0].filename
      this.setState({ coupon })
    }
  }

  _selectChange = (selectedProvider) => {
    let coupon = { ...this.state.coupon }
    coupon.provider_id = selectedProvider.value
    this.setState({
      selectedProvider,
      coupon
    })
  }

  _fileUploaded = (filename, field) => {
    let coupon = { ...this.state.coupon }
    coupon[field] = filename
    this.setState({ coupon })
  }

  _fileSelect = (event) => {
    const file = event.target
    this.setState({ file })
  }

  _upload = (event) => {
    event.preventDefault()
    let data = new FormData()
    data.append('files', this.state.file.files[0])
    data.append('type', 'coupon-image')

    this.props.upload(data)
    this.setState({ uploaded: true })
  }

  _couponChange = (event, field, isNumber = false) => {
    let val = event.target.value
    if (isNumber) {
      val = parseInt(val, 10)
    }
    let coupon = { ...this.state.coupon }
    coupon[field] = val
    if (field === 'code') {
      if (val.match(this.couponCodeRegex) === null) {
        return null
      }
      coupon[field] = val.substr(0, 14)
    }
    this.setState({ coupon })
  }

  _dateChange = (date, field) => {
    let coupon = { ...this.state.coupon }
    if (field === 'start_at') {
      if (moment(date) >= moment(this.state.coupon.end_at)) {
        coupon.end_at = moment(date).add(1, 'day')
      }
    }
    if (field === 'travel_date_start') {
      if (moment(date) >= moment(this.state.coupon.travel_date_end)) {
        coupon.travel_date_end = moment(date).add(1, 'day')
      }
    }
    coupon[field] = date
    this.setState({ coupon })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = { ...this.state.coupon }
    this.props.createCoupon(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    const { couponProvider } = this.props
    let providerPicker = []
    couponProvider.data && couponProvider.data.map((item, i) => (
      providerPicker[i] = {
        value: item.id,
        label: item.name
      }
    ))
    return (
      <section className='section' style={{ width: '85vw' }}>
        <div className='title-block'>
          <h3 className='title'>Create Coupon</h3>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='row'>
            <div className='col-6'>
              <div className='section'>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Title</label>
                  </div>
                  <div className='col-9'>
                    <input type='text' required placeholder='Coupon Title' className='form-control' value={this.state.coupon.title} onChange={(event) => this._couponChange(event, 'title')} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Code</label>
                  </div>
                  <div className='col-9'>
                    <input type='text' required placeholder='Coupon Code (max: 14 character)' className='form-control' value={this.state.coupon.code} onChange={(event) => this._couponChange(event, 'code')} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Type</label>
                  </div>
                  <div className='col-9'>
                    <select value={this.state.coupon.type} className='form-control' onChange={(event) => this._couponChange(event, 'type')}>
                      <option value='GENERIC'>Generic</option>
                      <option value='BUSINESS'>Business</option>
                    </select>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Status</label>
                  </div>
                  <div className='col-9'>
                    <select value={this.state.coupon.status} className='form-control' onChange={(event) => this._couponChange(event, 'status')}>
                      <option value='available'>Available</option>
                      <option value='unavailable'>Unavailable</option>
                    </select>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Platform</label>
                  </div>
                  <div className='col-9'>
                    <select value={this.state.coupon.platform} className='form-control' onChange={(event) => this._couponChange(event, 'platform')}>
                      {this.platforms.map((list, i) => <option key={i} value={list.value}>{ list.label }</option>)}
                    </select>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Product Type</label>
                  </div>
                  <div className='col-9'>
                    <select value={this.state.coupon.product_type} className='form-control' onChange={(event) => this._couponChange(event, 'product_type')}>
                      {this.productTypes.map((list, i) => <option key={i} value={list.value}>{ list.label }</option>)}
                    </select>
                  </div>
                </div>
                {
                  this.state.coupon.product_type === 'modem' &&
                  <div className='form-group row'>
                    <div className='col-3'>
                      <label className='control-label'>Rent Type</label>
                    </div>
                    <div className='col-9'>
                      <select value={this.state.coupon.rent_type} className='form-control' onChange={(event) => this._couponChange(event, 'rent_type')}>
                        {this.rentType.map((list, i) => <option key={i} value={list.value}>{ list.label }</option>)}
                      </select>
                    </div>
                  </div>
                }
                {
                  (this.state.coupon.product_type === 'modem' || this.state.coupon.product_type === 'all') &&
                  <div className='form-group row'>
                    <div className='col-3'>
                      <label className='control-label'>Duration</label>
                    </div>
                    <div className='col-9'>
                      <input type='number' min={0} className='form-control' value={this.state.coupon.min_duration} onChange={(event) => this._couponChange(event, 'min_duration', true)} />
                    </div>
                  </div>
                }
                {
                  this.state.coupon.product_type === 'modem' &&
                  <div className='form-group row'>
                    <div className='col-3'>
                      <label className='control-label'>Travel Start</label>
                    </div>
                    <div className='col-9'>
                      <DateTime
                        dateFormat={this.dateFormat}
                        timeFormat={false}
                        utc
                        isValidDate={current => current.isSameOrAfter(moment().subtract(1, 'day'))}
                        value={this.state.coupon.travel_date_start}
                        onChange={(date) => this._dateChange(date, 'travel_date_start')}
                        closeOnSelect
                      />
                    </div>
                  </div>
                }
                {
                  this.state.coupon.product_type === 'modem' &&
                  <div className='form-group row'>
                    <div className='col-3'>
                      <label className='control-label'>Travel End</label>
                    </div>
                    <div className='col-9'>
                      <DateTime
                        dateFormat={this.dateFormat}
                        timeFormat={false}
                        utc
                        isValidDate={current => current.isAfter(this.state.coupon.travel_date_start)}
                        value={this.state.coupon.travel_date_end}
                        onChange={(date) => this._dateChange(date, 'travel_date_end')}
                        closeOnSelect
                      />
                    </div>
                  </div>
                }
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Max Usage</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' min={0} className='form-control' value={this.state.coupon.max_usage} onChange={(event) => this._couponChange(event, 'max_usage', true)} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Max Usage Per User</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' min={0} className='form-control' value={this.state.coupon.max_usage_per_user} onChange={(event) => this._couponChange(event, 'max_usage_per_user', true)} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Discount Type</label>
                  </div>
                  <div className='col-9'>
                    <select value={this.state.coupon.discount_type} className='form-control' onChange={(event) => this._couponChange(event, 'discount_type')}>
                      <option value='PRICE_CUT'>PRICE CUT</option>
                      <option value='FULL_CUT'>FULL CUT</option>
                      {
                        (this.state.coupon.product_type === 'modem' || this.state.coupon.product_type === 'all') &&
                        this.state.coupon.min_duration > 0 &&
                        <option value='DURATION_CUT'>FULL CUT (DURATION BASED)</option>
                      }
                      {
                        this.state.coupon.product_type === 'modem' &&
                        this.state.coupon.min_duration > 0 &&
                        <option value='FULL_CUT_WITH_DEPOSIT'>FULL CUT (WITH DEPOSIT)</option>
                      }
                      <option value='PERCENTAGE_CUT'>PERCENTAGE CUT</option>
                    </select>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Discount Amount</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' className='form-control' value={this.state.coupon.discount_amount} onChange={(event) => this._couponChange(event, 'discount_amount', true)} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Max Discount</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' className='form-control' value={this.state.coupon.max_discount} onChange={(event) => this._couponChange(event, 'max_discount', true)} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Min Amount</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' className='form-control' value={this.state.coupon.min_amount} onChange={(event) => this._couponChange(event, 'min_amount', true)} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Max Amount</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' className='form-control' value={this.state.coupon.max_amount} onChange={(event) => this._couponChange(event, 'max_amount', true)} />
                  </div>
                </div>
              </div>
            </div>
            <div className='col-6'>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>First Order Only</label>
                </div>
                <div className='col-9'>
                  <SwitchButton isChecked={this.state.coupon.first_order_only} onChange={(event) => this._couponChange(event, 'first_order_only')} />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>First User Only</label>
                </div>
                <div className='col-9'>
                  <SwitchButton isChecked={this.state.coupon.first_user_only} onChange={(event) => this._couponChange(event, 'first_user_only')} />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>Start At</label>
                </div>
                <div className='col-9'>
                  <DateTime
                    value={this.state.coupon.start_at}
                    onChange={(date) => this._dateChange(date, 'start_at')}
                    closeOnSelect
                  />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>End At</label>
                </div>
                <div className='col-9'>
                  <DateTime
                    value={this.state.coupon.end_at}
                    isValidDate={current => current.isAfter(this.state.coupon.start_at)}
                    onChange={(date) => this._dateChange(date, 'end_at')}
                    closeOnSelect
                  />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>Description</label>
                </div>
                <div className='col-9'>
                  <textarea placeholder='Coupon Description' rows='3' value={this.state.coupon.description} className='form-control' onChange={(event) => this._couponChange(event, 'description')} />
                </div>
              </div>
              {
                currentBranch() !== 'PH' &&
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Coupon Provider</label>
                  </div>
                  <div className='col-9'>
                    <Select
                      options={providerPicker}
                      value={this.state.selectedProvider}
                      onChange={(selectedProvider) => this._selectChange(selectedProvider)}
                      required
                    />
                  </div>
                </div>
              }
              {
                currentBranch() !== 'PH' &&
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>ISO Code</label>
                  </div>
                  <div className='col-9'>
                    <select value={this.state.coupon.iso_code} className='form-control' onChange={(event) => this._couponChange(event, 'iso_code')}>
                      { this.iso_code.map((item, i) => (<option key={i} value={item.value}>{item.label}</option>)) }
                    </select>
                  </div>
                </div>
              }
              <div className='form-group'>
                <div className='row'>
                  <div className='col-3'>
                    <label htmlFor='image' className='control-label'>Image File (<span className='text-orange'>433x433</span>)</label>
                  </div>
                  <div className='col-9'>
                    <FileUploader setting={{ type: 'coupon-image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image_file')} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files,
  couponProvider: state.couponProvider
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
  createCoupon: (data) => dispatch(CouponActions.couponCreateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CreateCoupon)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/CreateCoupon.js